import { render, staticRenderFns } from "./nameAndDepart.vue?vue&type=template&id=049a2d72&scoped=true"
import script from "./nameAndDepart.vue?vue&type=script&lang=ts"
export * from "./nameAndDepart.vue?vue&type=script&lang=ts"
import style0 from "./nameAndDepart.vue?vue&type=style&index=0&id=049a2d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a2d72",
  null
  
)

export default component.exports